var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCallRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Phone_call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 223",
    d: "M14.4099 8.561C14.2086 8.01402 13.8947 7.51537 13.4886 7.09728C13.0825 6.67919 12.5931 6.35095 12.0522 6.13379",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 224",
    d: "M17.7442 8.05916C17.4035 6.7875 16.734 5.62793 15.8031 4.697C14.8722 3.76608 13.7126 3.0966 12.4409 2.75586",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45432 7.20237C8.79053 8.41718 8.41236 9.68452 7.58375 10.4657C7.42665 10.6138 7.37601 10.8532 7.49944 11.0304C7.76217 11.4076 8.06098 11.7661 8.39604 12.1014C8.73059 12.4362 9.08825 12.7349 9.46453 12.9976C9.64218 13.1216 9.88234 13.0701 10.0302 12.9117C10.8101 12.0765 12.0811 11.6942 13.2993 12.0318C14.9412 12.4869 15.8653 14.0777 15.3633 15.5848C13.8925 20.0015 8.22954 15.6238 6.55292 13.9459C4.83578 12.2275 0.525439 6.59711 4.90396 5.13675C6.41001 4.63441 7.99955 5.55923 8.45432 7.20237Z",
    stroke: "white",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCallRing);
export default __webpack_public_path__ + "static/media/Phone_call_ring.71b3a8e2957103b33889e1b284e85276.svg";
export { ForwardRef as ReactComponent };